import React ,{useEffect} from "react";
import { project_mockup1 } from "../Assets";
import { FiLink } from "react-icons/fi";
import { Link } from "react-router-dom";
import AOS from 'aos';


const ProjectLeftCard = ({bannerimg , ind , bgColor , liveLink ,name}) => {

  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration in milliseconds
      easing: 'ease-in-out', // Easing function for the animation
    });
    console.log(bgColor)
  }, []);


  return (
    <>
      <div className="project-left-main-content-box" data-aos="fade-right" data-aos-delay="300" >
        <div className="project-count-box-left" data-aos="fade-up" data-aos-delay="700">0{ind + 1}</div>
        <div style={{backgroundColor : bgColor}} className="project-showcase-left-img-box project-showcase-card-box" data-aos="fade-right" data-aos-delay="300">
          <img src={bannerimg}></img>
          <div className="projects-link-box-cover">
            <div className="projects-link-box">
              <button className="project-link-btn">
                <Link to={liveLink} target="__blank">
                    Live Link{" "}
                    <span>
                      <FiLink />
                    </span>
                </Link>
              </button>
            </div>
          </div>
          <div className="project-details-btn-box">
          <div className="project-btn-icon"></div>
          <button>
            <Link to={`/project${ind}-details`}>{name}</Link>
          </button>
        </div>
        </div>
        
      </div>
    </>
  );
};

export default ProjectLeftCard;
